<template>
  <div v-if="isRoot" class="fixed top-1/2 right-0 z-[99999999] flex -translate-y-1/2 items-stretch">
    <!-- Toggle button, fixed on the right edge -->
    <button
      type="button"
      :aria-expanded="open"
      aria-label="Nastavení zobrazení"
      class="flex h-12 w-10 items-center justify-center rounded-l-md bg-[var(--p-primary-color)] text-white shadow-md transition-colors hover:opacity-90"
      @click="open = !open"
    >
      <span class="text-lg font-semibold leading-none">Aa</span>
    </button>

    <!-- Panel slides out from behind the button -->
    <div
      class="flex flex-col gap-3 overflow-hidden bg-white shadow-lg transition-all duration-300 ease-in-out"
      :class="open ? 'w-56 px-4 py-3 opacity-100' : 'w-0 px-0 py-0 opacity-0'"
    >
      <div class="flex items-center justify-between whitespace-nowrap">
        <span class="text-sm font-medium text-gray-700">Velikost písma</span>
        <span class="text-sm font-semibold text-gray-900">{{ fontSize }}px</span>
      </div>
      <Slider v-model="fontSize" :min="min" :max="max" :step="1" />

      <!-- Where the „N realizací a M návrhů" line sits relative to the homepage CTA buttons. -->
      <div class="mt-2 flex flex-col gap-2 whitespace-nowrap border-t border-gray-200 pt-3">
        <span class="text-sm font-medium text-gray-700">Počty projektů u CTA</span>
        <SelectButton
          v-model="placement"
          :options="placementOptions"
          option-label="label"
          option-value="value"
          :allow-empty="false"
          size="small"
          aria-label="Umístění počtů projektů u CTA tlačítka"
        />
      </div>

      <!-- `/` shows the dashboard to logged-in members; `?guest=1` forces the guest (sales) homepage
           for root admins so the CMS blocks can be checked while logged in (see pages/index.vue). -->
      <NuxtLinkLocale
        :to="{ path: '/', query: { guest: '1' } }"
        class="mt-2 inline-flex items-center justify-center rounded-md border border-gray-300 px-3 py-1.5 text-sm font-medium whitespace-nowrap text-gray-700 transition-colors hover:bg-gray-100"
      >
        Zobrazit HP pro hosty
      </NuxtLinkLocale>
    </div>
  </div>
</template>

<script setup lang="ts">
import Slider from 'primevue/slider'
import SelectButton from 'primevue/selectbutton'
import type { CtaCountsPlacement } from '~~/shared-project-components/content/blocks/_shared/projects/useCtaCountsPlacement'
import { useCtaCountsPlacement } from '~~/shared-project-components/content/blocks/_shared/projects/useCtaCountsPlacement'

const { $auth } = useNuxtApp()
const isRoot = computed(() => !!$auth?.isRoot?.value)

const { fontSize, min, max } = useFontSize()
const open = ref(false)

const { placement } = useCtaCountsPlacement()
const placementOptions: { label: string; value: CtaCountsPlacement }[] = [
  { label: 'V tlačítku', value: 'inside' },
  { label: 'Pod tlačítkem', value: 'below' },
]
</script>
